import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01e1d906"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"cursor__disc\" data-v-01e1d906><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 104 104\" data-v-01e1d906><circle cx=\"52\" cy=\"52\" r=\"43\" fill=\"#FD349C\" class=\"cursor__circle cursor__circle--standard\" data-v-01e1d906></circle><circle cx=\"52\" cy=\"52\" r=\"43\" stroke=\"#FD349C\" stroke-width=\"3\" class=\"cursor__circle cursor__circle--stroke\" data-v-01e1d906></circle></svg><p class=\"cursor__word\" data-v-01e1d906>Explore</p></div><div class=\"cursor__cross\" data-v-01e1d906></div><div class=\"cursor__arrows\" data-v-01e1d906><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 104 104\" data-v-01e1d906><circle cx=\"52\" cy=\"52\" r=\"43\" fill=\"none\" stroke=\"#ffffff\" stroke-width=\"2\" data-v-01e1d906></circle></svg><div class=\"cursor__arrow cursor__arrow--left\" data-v-01e1d906></div><div class=\"cursor__arrow cursor__arrow--right\" data-v-01e1d906></div></div>", 3)
const _hoisted_4 = [
  _hoisted_1
]


const __default__ = {
  name: 'CustomCursor',
};

import {
  onMounted,
  ref,
  watch,
} from 'vue';

import { useRoute } from 'vue-router';
import { useStore } from '@/store';
import Cursor from '@/widgets/Cursor';
// import SVGLoader from '@/svgs/loader.svg';
// import SVGArrowLeft from '@/svgs/arrow-left.svg';
// import SVGArrowRight from '@/svgs/arrow-right.svg';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const cursor = ref<Cursor>();
const cursorRef = ref<HTMLDivElement>();
const store = useStore();
const route = useRoute();

watch(() => route.name, () => {
  if (cursor.value) {
    cursor.value.shrink();
  }
});

onMounted(() => {
  if (store.state.status.isMobile || !cursorRef.value) {
    return;
  }

  cursor.value = new Cursor(cursorRef.value);
  cursor.value.events();
  cursor.value.init();

  const instance = {
    shrink: cursor.value.shrink,
    crossOff: cursor.value.crossOff,
    reset: cursor.value.resetElements,
    add: cursor.value.add,
    remove: cursor.value.remove,
  };

  store.commit('widgets/add', { instance, instanceKey: 'cursor' });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "cursorRef",
    ref: cursorRef,
    class: "cursor",
    "data-light": "false",
    "data-expand": "false",
    "data-small": "false",
    "data-cross": "false",
    "data-arrows": "false",
    "data-direction": "null",
    "data-hidden": "false",
    "data-back": "false",
    "data-theme": "primary"
  }, _hoisted_4, 512))
}
}

})